const activeTab = document.querySelector('.tabs .active');
if (activeTab) activeTab.scrollIntoView(false);
